<template>
<div class="tag_board">
<el-row>
  <el-col :span="12" class="left">
    <div class="order">{{this.orderQuality}}</div>
    <div class="title">{{this.title}}</div>
  </el-col>
  <el-col :span="12" class="right">
    <div><el-icon class="el-icon-s-order"></el-icon></div>
  </el-col>
</el-row>
</div>
</template>

<script>
export default {
  name: "Tag",
  props:{
    orderQuality:{
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: ''
    }
  },
  data(){
    return{

    }
  }
}
</script>

<style scoped>
.tag_board{
  background-color: white;
  border-radius: 5px;
  padding: 0.5rem;
}
.tag_board .left{

}
.tag_board .left .title{
  font-size: 14px;
}
.tag_board .left .order{
  font-size: 1.5rem;
  font-weight: 700;
}
.tag_board .right .el-icon-s-order{
  font-size: 3rem;
  color: #409EFF;
}
</style>
